export default __webpack_public_path__ + "placeholderSmLogo.9394bc3bda28a2a2304b6b4097de4420.png";